import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, getMe } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not auth

  useEffect(() => {
    const t = localStorage.getItem("sf_token");
    if (!t) { setUser(null); return; }
    getMe().then(setUser).catch(() => { localStorage.removeItem("sf_token"); setUser(null); });
  }, []);

  const signIn = useCallback(async (username, password) => {
    const data = await apiLogin(username, password);
    localStorage.setItem("sf_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("sf_token");
    setUser(null);
  }, []);

  const isAdmin = user?.role === "admin";
  return <Ctx.Provider value={{ user, signIn, signOut, isAdmin }}>{children}</Ctx.Provider>;
}
